function MemberLoginService($q, $rootScope, $sessionStorage, halClient, BBModel) {
    'ngInject';

    return {
        login(form, options) {
            const defer = $q.defer();
            let url = `${$rootScope.bb.api_url}/api/v1/login`;
            if (options.company_id != null) {
                url = `${url}/member/${options.company_id}`;
            }
            halClient.$post(url, options, form).then((login) => {
                    if (login.$has('member')) {
                        return login.$get('member').then((member) => {
                            member = new BBModel.Member.Member(member);
                            const auth_token = member._data.getOption('auth_token');
                            $sessionStorage.setItem('login', member.$toStore());
                            $sessionStorage.setItem('auth_token', auth_token);
                            return defer.resolve(member);
                        });
                    } else if (login.$has('members')) {
                        return defer.resolve(login);
                    } else {
                        return defer.reject('No member account for login');
                    }
                }
                , (err) => {
                    if (err.status === 400) {
                        const login = halClient.$parse(err.data);
                        if (login.$has('members')) {
                            return defer.resolve(login);
                        } else {
                            return defer.reject(err);
                        }
                    } else {
                        return defer.reject(err);
                    }
                }
            );
            return defer.promise;
        }
    };
}

angular
    .module('BBMember')
    .service('MemberLoginService', MemberLoginService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/_services/member_login.service.js